import { Icon } from '@/core/icon';
import { Dialog, DialogClose, DialogContent, DialogTitle, Typography } from '@/core/ui';
import { useAppDispatch, useAppSelector } from '@/store';
import { setPresidentModal } from '@/store/history';
import type { IHistoryPresidents } from '@/types';
import { useTranslation } from 'react-i18next';
import { PlayerDetail } from './president/detail';
import { PresidentList } from './president/list';

export const Slide3 = ({ presidents, title }: IHistoryPresidents & { title: string }) => {
  const open = useAppSelector((s) => s.history.presidentModal);
  const dispatch = useAppDispatch();
  const { t } = useTranslation('translation');

  const setModal = (val: boolean) => () => {
    dispatch(setPresidentModal(val));
  };

  return (
    <>
      <Dialog open={open} onOpenChange={setModal(false)}>
        <DialogContent
          closeJsx={
            <DialogClose
              onClick={setModal(false)}
              className='absolute right-8 top-8 rounded-sm ring-offset-background transition-opacity hover:opacity-100 focus:outline-none disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground'
            >
              <Icon name={'X_ICON'} className='p-2 w-16 h-16' color='rgb(var(--color-danger))' />
              <span className='sr-only'>Close</span>
            </DialogClose>
          }
          className='bg-transparent flex justify-center items-center overflow-hidden shadow-none h-[80%] max-w-[90%] sm:rounded-2xl'
        >
          <DialogTitle />
          <PlayerDetail />
        </DialogContent>
      </Dialog>
      <div className='bg-content1 flex flex-col space-y-24 h-screen px-44 py-16'>
        <div>
          <Typography className='text-chalk text-3xl tracking-[1.5px] leading-[28.5px]'>
            {t('history.member.president')}
          </Typography>
        </div>
        <div className='flex flex-row justify-between pr-0'>
          <div className='flex flex-col space-y-16'>
            <Typography className='text-chalk capitalize text-3xl tracking-[1.5px] leading-[28.5px]'>
              {title}
            </Typography>
            <PresidentList presidents={presidents} />
          </div>
        </div>
      </div>
    </>
  );
};
